import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOther = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 6V12L9.00195 15.5L3 12V6L9 2.5L15 6ZM4 6.57715V10L9 12.8457L14 10V6.57715L9 3.6543L4 6.57715Z",
		fill: "black"
	})
});
export default SvgOther;
